import { LoaderFunctionArgs } from 'react-router-dom'
import { getPhotoByHash } from '../../action'

export const warrantyPhotoPageLoader = async (args: LoaderFunctionArgs) => {
    await getPhotoByHash(args.params.id as string)

    return null
}
